var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.999919 0H12.9999C13.1767 0 13.3463 0.0702379 13.4713 0.195262C13.5963 0.320286 13.6666 0.489856 13.6666 0.666667V11.3333C13.6666 11.5101 13.5963 11.6797 13.4713 11.8047C13.3463 11.9298 13.1767 12 12.9999 12H0.999919C0.823108 12 0.653538 11.9298 0.528514 11.8047C0.40349 11.6797 0.333252 11.5101 0.333252 11.3333V0.666667C0.333252 0.489856 0.40349 0.320286 0.528514 0.195262C0.653538 0.0702379 0.823108 0 0.999919 0ZM12.3333 2.82533L7.04792 7.55867L1.66659 2.81067V10.6667H12.3333V2.82533ZM2.00725 1.33333L7.04059 5.77467L12.0013 1.33333H2.00725Z",
    fill: "#CC000A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.8c659873dd09d53d4344c820a2065e8d.svg";
export { ForwardRef as ReactComponent };